/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as t, isNone as e } from "../../../core/maybe.js";
import n from "../PixelBlock.js";

function i(e) {
  return t(e) && "esri.layers.support.PixelBlock" === e.declaredClass && e.pixels && e.pixels.length > 0;
}

function l(t, e) {
  if (null == e || !e.length || !i(t)) return t;
  var l = t.pixels.length;
  return e && e.some(function (t) {
    return t >= l;
  }) || 1 === l && 1 === e.length && 0 === e[0] ? t : l !== e.length || e.some(function (t, e) {
    return t !== e;
  }) ? new n({
    pixelType: t.pixelType,
    width: t.width,
    height: t.height,
    mask: t.mask,
    validPixelCount: t.validPixelCount,
    maskIsAlpha: t.maskIsAlpha,
    pixels: e.map(function (e) {
      return t.pixels[e];
    }),
    statistics: t.statistics && e.map(function (e) {
      return t.statistics[e];
    })
  }) : t;
}

function o(t) {
  if (!t) return;
  var e = t.colormap;
  if (!e || 0 === e.length) return;
  var n = e.sort(function (t, e) {
    return t[0] - e[0];
  });
  var i = 0;
  n[0][0] < 0 && (i = n[0][0]);
  var l = Math.max(256, n[n.length - 1][0] - i + 1),
      o = new Uint8Array(4 * l),
      r = [];
  var s,
      a = 0,
      f = 0;
  var h = 5 === n[0].length;
  if (l > 65536) return n.forEach(function (t) {
    r[t[0] - i] = h ? t.slice(1) : t.slice(1).concat([255]);
  }), {
    indexed2DColormap: r,
    offset: i,
    alphaSpecified: h
  };
  if (t.fillUnspecified) for (s = n[f], a = s[0] - i; a < l; a++) {
    o[4 * a] = s[1], o[4 * a + 1] = s[2], o[4 * a + 2] = s[3], o[4 * a + 3] = h ? s[4] : 255, a === s[0] - i && (s = f === n.length - 1 ? s : n[++f]);
  } else for (a = 0; a < n.length; a++) {
    s = n[a], f = 4 * (s[0] - i), o[f] = s[1], o[f + 1] = s[2], o[f + 2] = s[3], o[f + 3] = h ? s[4] : 255;
  }
  return {
    indexedColormap: o,
    offset: i,
    alphaSpecified: h
  };
}

function r(t, e) {
  if (!i(t)) return t;
  if (!e && (e.indexedColormap || e.indexed2DColormap)) return t;
  var n = t.clone(),
      l = n.pixels;
  var o = n.mask;
  var r = n.width * n.height;
  if (1 !== l.length) return t;
  var s = e.indexedColormap,
      a = e.indexed2DColormap,
      f = e.offset,
      h = e.alphaSpecified,
      u = s.length - 1;
  var c = 0;
  var p = l[0],
      x = new Uint8Array(p.length),
      m = new Uint8Array(p.length),
      d = new Uint8Array(p.length);
  var g,
      y = 0;
  if (s) {
    if (o) for (c = 0; c < r; c++) {
      o[c] && (y = 4 * (p[c] - f), y < f || y > u ? o[c] = 0 : (x[c] = s[y], m[c] = s[y + 1], d[c] = s[y + 2], o[c] = s[y + 3]));
    } else {
      for (o = new Uint8Array(r), c = 0; c < r; c++) {
        y = 4 * (p[c] - f), y < f || y > u ? o[c] = 0 : (x[c] = s[y], m[c] = s[y + 1], d[c] = s[y + 2], o[c] = s[y + 3]);
      }

      n.mask = o;
    }
  } else if (o) for (c = 0; c < r; c++) {
    o[c] && (g = a[p[c]], x[c] = g[0], m[c] = g[1], d[c] = g[2], o[c] = g[3]);
  } else {
    for (o = new Uint8Array(r), c = 0; c < r; c++) {
      g = a[p[c]], x[c] = g[0], m[c] = g[1], d[c] = g[2], o[c] = g[3];
    }

    n.mask = o;
  }
  return n.pixels = [x, m, d], n.statistics = null, n.pixelType = "u8", n.maskIsAlpha = h, n;
}

function s(t) {
  if (!i(t)) return null;
  t.statistics || t.updateStatistics();
  var e = t.pixels,
      n = t.mask,
      l = t.pixelType,
      o = t.statistics,
      r = t.width * t.height,
      s = e.length;
  var a, f, h, u, c;
  var p = [],
      x = [];
  var m, d, g, y, w, M, k, A, U, C;
  var T = 256;

  for (u = 0; u < s; u++) {
    if (m = new Uint32Array(T), g = e[u], "u8" === l) {
      if (a = -.5, f = 255.5, n) for (c = 0; c < r; c++) {
        n[c] && m[g[c]]++;
      } else for (c = 0; c < r; c++) {
        m[g[c]]++;
      }
    } else {
      if (a = o[u].minValue, f = o[u].maxValue, h = (f - a) / T, d = new Uint32Array(T + 1), n) for (c = 0; c < r; c++) {
        n[c] && d[Math.floor((g[c] - a) / h)]++;
      } else for (c = 0; c < r; c++) {
        d[Math.floor((g[c] - a) / h)]++;
      }

      for (c = 0; c < 255; c++) {
        m[c] = d[c];
      }

      m[255] = d[255] + d[256];
    }

    for (p.push({
      min: a,
      max: f,
      size: T,
      counts: m
    }), y = 0, w = 0, A = 0, c = 0; c < T; c++) {
      y += m[c], w += c * m[c];
    }

    for (U = w / y, c = 0; c < T; c++) {
      A += m[c] * Math.pow(c - U, 2);
    }

    C = Math.sqrt(A / (y - 1)), h = (f - a) / T, M = (U + .5) * h + a, k = C * h, x.push({
      min: a,
      max: f,
      avg: M,
      stddev: k
    });
  }

  return {
    statistics: x,
    histograms: p
  };
}

function a(t) {
  var e = [];

  for (var _n = 0; _n < t.length; _n++) {
    var _t$_n = t[_n],
        _i = _t$_n.min,
        _l = _t$_n.max,
        _o = _t$_n.size,
        _r = _t$_n.counts;
    var _s = 0,
        _a = 0;

    for (var _t = 0; _t < _o; _t++) {
      _s += _r[_t], _a += _t * _r[_t];
    }

    var _f = _a / _s;

    var _h = 0;

    for (var _t2 = 0; _t2 < _o; _t2++) {
      _h += _r[_t2] * Math.pow(_t2 - _f, 2);
    }

    var _u = (_l - _i) / _o,
        _c = (_f + .5) * _u + _i,
        _p = Math.sqrt(_h / (_s - 1)) * _u;

    e.push({
      min: _i,
      max: _l,
      avg: _c,
      stddev: _p
    });
  }

  return e;
}

function f(t) {
  var e = t.minCutOff,
      n = t.maxCutOff,
      i = t.gamma,
      l = t.pixelType,
      o = t.outMin || 0,
      r = t.outMax || 255;
  if (-1 === ["u8", "u16", "s8", "s16"].indexOf(l)) return null;
  var s = e.length;
  var a,
      f,
      u = 0;
  "s8" === l ? u = -127 : "s16" === l && (u = -32767);
  var c = 256;
  ["u16", "s16"].indexOf(l) > -1 && (c = 65536);
  var p = [],
      x = [],
      m = r - o;

  for (a = 0; a < s; a++) {
    x[a] = n[a] - e[a], p[a] = m / (n[a] - e[a]);
  }

  var d = i && i.length >= s,
      g = [];
  if (d) for (a = 0; a < s; a++) {
    i[a] > 1 ? i[a] > 2 ? g[a] = 6.5 + Math.pow(i[a] - 2, 2.5) : g[a] = 6.5 + 100 * Math.pow(2 - i[a], 4) : g[a] = 1;
  }
  var y;
  var w = [];
  var M, k, A;
  if (d) for (a = 0; a < s; a++) {
    for (A = [], f = 0; f < c; f++) {
      M = f + u, y = (M - e[a]) / x[a], k = 1, i[a] > 1 && (k -= Math.pow(1 / m, y * g[a])), M < n[a] && M > e[a] ? A[f] = Math.floor(k * m * Math.pow(y, 1 / i[a])) + o : M >= n[a] ? A[f] = r : A[f] = o;
    }

    w[a] = A;
  } else for (a = 0; a < s; a++) {
    for (A = [], f = 0; f < c; f++) {
      M = f + u, M <= e[a] ? A[f] = o : M >= n[a] ? A[f] = r : A[f] = Math.floor((M - e[a]) / x[a] * m) + o;
    }

    w[a] = A;
  }

  if (null != t.contrastOffset) {
    var _e = h(t.contrastOffset, t.brightnessOffset);

    for (a = 0; a < s; a++) {
      for (A = w[a], f = 0; f < c; f++) {
        A[f] = _e[A[f]];
      }
    }
  }

  return {
    lut: w,
    offset: u
  };
}

function h(t, e) {
  var n = Math.min(Math.max(t, -100), 100),
      i = Math.min(Math.max(e, -100), 100),
      l = 255,
      o = 128;
  var r, s;
  var a = new Uint8Array(256);

  for (r = 0; r < 256; r++) {
    n > 0 && n < 100 ? s = (200 * r - 100 * l + 2 * l * i) / (2 * (100 - n)) + o : n <= 0 && n > -100 ? s = (200 * r - 100 * l + 2 * l * i) * (100 + n) / 2e4 + o : 100 === n ? (s = 200 * r - 100 * l + (l + 1) * (100 - n) + 2 * l * i, s = s > 0 ? l : 0) : -100 === n && (s = o), a[r] = s > l ? l : s < 0 ? 0 : s;
  }

  return a;
}

function u(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
  e = Math.min(e, 256);
  var n = t.size,
      i = t.counts,
      l = new Uint8Array(n),
      o = i.reduce(function (t, n) {
    return t + n / e;
  }, 0);
  var r = 0,
      s = 0,
      a = 0,
      f = o;

  for (var _h2 = 0; _h2 < n; _h2++) {
    if (a += i[_h2], !(_h2 < n - 1 && a + i[_h2 + 1] < f)) {
      for (; r < e - 1 && f < a;) {
        r++, f += o;
      }

      for (var _t3 = s; _t3 <= _h2; _t3++) {
        l[_t3] = r;
      }

      s = _h2 + 1;
    }
  }

  for (var _h3 = s; _h3 < n; _h3++) {
    l[_h3] = e - 1;
  }

  return l;
}

function c(t, e) {
  if (!i(t)) return null;
  var n = t.clone(),
      l = n.pixels,
      o = n.mask,
      r = e.minCutOff,
      s = e.maxCutOff,
      a = e.gamma,
      f = e.outMin || 0,
      h = e.outMax || 255,
      u = n.width * n.height,
      c = l.length;
  var p, x, m, d, g;
  var y = h - f,
      w = [],
      M = [];

  for (p = 0; p < c; p++) {
    M[p] = s[p] - r[p], w[p] = y / (s[p] - r[p]);
  }

  var k = a && a.length >= c,
      A = [];
  if (k) for (p = 0; p < c; p++) {
    a[p] > 1 ? a[p] > 2 ? A[p] = 6.5 + Math.pow(a[p] - 2, 2.5) : A[p] = 6.5 + 100 * Math.pow(2 - a[p], 4) : A[p] = 1;
  }
  if (k) {
    if (null != o) {
      for (x = 0; x < u; x++) {
        if (o[x]) for (p = 0; p < c; p++) {
          m = l[p][x], g = (m - r[p]) / M[p], d = 1, a[p] > 1 && (d -= Math.pow(1 / y, g * A[p])), m < s[p] && m > r[p] ? l[p][x] = Math.floor(d * y * Math.pow(g, 1 / a[p])) + f : m >= s[p] ? l[p][x] = h : l[p][x] = f;
        }
      }
    } else for (x = 0; x < u; x++) {
      for (p = 0; p < c; p++) {
        m = l[p][x], g = (m - r[p]) / M[p], d = 1, a[p] > 1 && (d -= Math.pow(1 / y, g * A[p])), m < s[p] && m > r[p] ? l[p][x] = Math.floor(d * y * Math.pow(g, 1 / a[p])) + f : m >= s[p] ? l[p][x] = h : l[p][x] = f;
      }
    }
  } else if (null != o) {
    for (x = 0; x < u; x++) {
      if (o[x]) for (p = 0; p < c; p++) {
        m = l[p][x], m < s[p] && m > r[p] ? l[p][x] = Math.floor((m - r[p]) / M[p] * y) + f : m >= s[p] ? l[p][x] = h : l[p][x] = f;
      }
    }
  } else for (x = 0; x < u; x++) {
    for (p = 0; p < c; p++) {
      m = l[p][x], m < s[p] && m > r[p] ? l[p][x] = Math.floor((m - r[p]) / M[p] * y) + f : m >= s[p] ? l[p][x] = h : l[p][x] = f;
    }
  }
  return n.pixelType = "u8", n.updateStatistics(), n;
}

function p(t, e) {
  if (!i(t)) return null;
  var l = t.pixels,
      o = t.mask,
      r = t.width * t.height,
      s = l.length;
  var a = e.lut;
  var f = e.offset;
  var h, u;
  a && 1 === a[0].length && (a = l.map(function () {
    return a;
  }));
  var c = [];
  var p, x, m;
  if (f) {
    if (null == o) for (h = 0; h < s; h++) {
      for (p = l[h], x = a[h], m = new Uint8Array(r), u = 0; u < r; u++) {
        m[u] = x[p[u] - f];
      }

      c.push(m);
    } else for (h = 0; h < s; h++) {
      for (p = l[h], x = a[h], m = new Uint8Array(r), u = 0; u < r; u++) {
        o[u] && (m[u] = x[p[u] - f]);
      }

      c.push(m);
    }
  } else if (null == o) for (h = 0; h < s; h++) {
    for (p = l[h], x = a[h], m = new Uint8Array(r), u = 0; u < r; u++) {
      m[u] = x[p[u]];
    }

    c.push(m);
  } else for (h = 0; h < s; h++) {
    for (p = l[h], x = a[h], m = new Uint8Array(r), u = 0; u < r; u++) {
      o[u] && (m[u] = x[p[u]]);
    }

    c.push(m);
  }
  var d = new n({
    width: t.width,
    height: t.height,
    pixels: c,
    mask: o,
    pixelType: "u8"
  });
  return d.updateStatistics(), d;
}

function x(t, e) {
  if (!i(t)) return null;
  var n = t.clone(),
      l = n.pixels,
      o = n.width * n.height,
      r = e.length,
      s = Math.floor(r / 2),
      a = e[Math.floor(s)],
      f = l[0];
  var h,
      u,
      c,
      p,
      x,
      m,
      d = !1;
  var g = new Uint8Array(o),
      y = new Uint8Array(o),
      w = new Uint8Array(o);
  var M = n.mask;
  var k = 4 === e[0].mappedColor.length;

  for (M || (M = new Uint8Array(o), M.fill(k ? 255 : 1), n.mask = M), x = 0; x < o; x++) {
    if (M[x]) {
      for (h = f[x], d = !1, m = s, u = a, c = 0, p = r - 1; p - c > 1;) {
        if (h === u.value) {
          d = !0;
          break;
        }

        h > u.value ? c = m : p = m, m = Math.floor((c + p) / 2), u = e[Math.floor(m)];
      }

      d || (h === e[c].value ? (u = e[c], d = !0) : h === e[p].value ? (u = e[p], d = !0) : h < e[c].value ? (d = !1, u = null) : h > e[c].value && (h < e[p].value ? (u = e[c], d = !0) : p === r - 1 ? (d = !1, u = null) : (u = e[p], d = !0))), d ? (g[x] = u.mappedColor[0], y[x] = u.mappedColor[1], w[x] = u.mappedColor[2], M[x] = u.mappedColor[3]) : g[x] = y[x] = w[x] = M[x] = 0;
    }
  }

  return n.pixels = [g, y, w], n.mask = M, n.pixelType = "u8", n.maskIsAlpha = k, n;
}

function m(t, e, n, i, l, o, r, s) {
  return {
    xmin: l <= n * t ? 0 : l < n * t + t ? l - n * t : t,
    ymin: o <= i * e ? 0 : o < i * e + e ? o - i * e : e,
    xmax: l + r <= n * t ? 0 : l + r < n * t + t ? l + r - n * t : t,
    ymax: o + s <= i * e ? 0 : o + s < i * e + e ? o + s - i * e : e
  };
}

function d(t, n) {
  if (!t || 0 === t.length) return null;
  var i = t.filter(function (t) {
    return t.pixelBlock;
  })[0];
  if (!i || e(i.pixelBlock)) return null;
  var l = (i.extent.xmax - i.extent.xmin) / i.pixelBlock.width,
      o = (i.extent.ymax - i.extent.ymin) / i.pixelBlock.height,
      r = .01 * Math.min(l, o),
      s = t.sort(function (t, e) {
    return Math.abs(t.extent.ymax - e.extent.ymax) > r ? e.extent.ymax - t.extent.ymax : Math.abs(t.extent.xmin - e.extent.xmin) > r ? t.extent.xmin - e.extent.xmin : 0;
  }),
      a = Math.min.apply(null, s.map(function (t) {
    return t.extent.xmin;
  })),
      f = Math.min.apply(null, s.map(function (t) {
    return t.extent.ymin;
  })),
      h = Math.max.apply(null, s.map(function (t) {
    return t.extent.xmax;
  })),
      u = Math.max.apply(null, s.map(function (t) {
    return t.extent.ymax;
  })),
      c = {
    x: Math.round((n.xmin - a) / l),
    y: Math.round((u - n.ymax) / o)
  },
      p = {
    width: Math.round((h - a) / l),
    height: Math.round((u - f) / o)
  },
      x = {
    width: Math.round((n.xmax - n.xmin) / l),
    height: Math.round((n.ymax - n.ymin) / o)
  };
  if (Math.round(p.width / i.pixelBlock.width) * Math.round(p.height / i.pixelBlock.height) !== s.length || c.x < 0 || c.y < 0 || p.width < x.width || p.height < x.height) return null;
  return {
    extent: n,
    pixelBlock: y(s.map(function (t) {
      return t.pixelBlock;
    }), p, {
      clipOffset: c,
      clipSize: x
    })
  };
}

function g(t, e, n, i, l, o) {
  var _n$block = n.block,
      r = _n$block.width,
      s = _n$block.height,
      _n$offset = n.offset,
      a = _n$offset.x,
      f = _n$offset.y,
      _n$mosaic = n.mosaic,
      h = _n$mosaic.width,
      u = _n$mosaic.height,
      c = m(r, s, i, l, a, f, h, u);
  var p = 0,
      x = 0;

  if (o) {
    var _t4 = o.hasGCSSShiftTransform ? 360 : o.halfWorldWidth,
        _e2 = r * o.resolutionX,
        _n2 = o.startX + i * _e2,
        _l2 = _n2 + _e2;

    _n2 < _t4 && _l2 > _t4 ? x = o.rightPadding : _n2 >= _t4 && (p = o.leftMargin - o.rightPadding, x = 0);
  }

  if (c.xmax -= x, "number" != typeof e) for (var _m = c.ymin; _m < c.ymax; _m++) {
    var _n3 = (l * s + _m - f) * h + (i * r - a) + p,
        _o2 = _m * r;

    for (var _i2 = c.xmin; _i2 < c.xmax; _i2++) {
      t[_n3 + _i2] = e[_o2 + _i2];
    }
  } else for (var _m2 = c.ymin; _m2 < c.ymax; _m2++) {
    var _n4 = (l * s + _m2 - f) * h + (i * r - a) + p;

    for (var _i3 = c.xmin; _i3 < c.xmax; _i3++) {
      t[_n4 + _i3] = e;
    }
  }
}

function y(l, o) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var s = r.clipOffset,
      a = r.clipSize,
      f = r.alignmentInfo,
      h = r.blockWidths;
  if (h) return w(l, o, {
    blockWidths: h
  });
  var u = l.filter(function (t) {
    return i(t);
  })[0];
  if (e(u)) return null;
  var c = a ? a.width : o.width,
      p = a ? a.height : o.height,
      x = u.width,
      m = u.height,
      d = o.width / x,
      y = o.height / m,
      M = {
    offset: s || {
      x: 0,
      y: 0
    },
    mosaic: a || o,
    block: {
      width: x,
      height: m
    }
  },
      k = u.pixelType,
      A = n.getPixelArrayConstructor(k),
      U = u.pixels.length,
      C = [];
  var T, S;

  for (var _t5 = 0; _t5 < U; _t5++) {
    S = new A(c * p);

    for (var _e3 = 0; _e3 < y; _e3++) {
      for (var _n5 = 0; _n5 < d; _n5++) {
        var _o3 = l[_e3 * d + _n5];
        i(_o3) && (T = _o3.pixels[_t5], g(S, T, M, _n5, _e3, f));
      }
    }

    C.push(S);
  }

  var v;

  if (l.some(function (t) {
    return e(t) || t.mask && t.mask.length > 0;
  })) {
    v = new Uint8Array(c * p);

    for (var _e4 = 0; _e4 < y; _e4++) {
      for (var _n6 = 0; _n6 < d; _n6++) {
        var _i4 = l[_e4 * d + _n6],
            _o4 = t(_i4) ? _i4.mask : null;

        g(v, _o4 || (_i4 ? 1 : 0), M, _n6, _e4, f);
      }
    }
  }

  var B = new n({
    width: c,
    height: p,
    pixels: C,
    pixelType: k,
    mask: v
  });
  return B.updateStatistics(), B;
}

function w(e, l, o) {
  var r = e.find(function (e) {
    return t(e);
  });
  if (!t(r)) return null;
  var s = e.some(function (e) {
    return !t(e) || !!e.mask;
  }),
      a = l.width,
      f = l.height,
      h = s ? new Uint8Array(a * f) : null,
      u = o.blockWidths,
      c = [],
      p = r.getPlaneCount(),
      x = n.getPixelArrayConstructor(r.pixelType);
  if (s) for (var _t6 = 0, _n7 = 0; _t6 < e.length; _n7 += u[_t6], _t6++) {
    var _l3 = e[_t6];
    if (!i(_l3)) continue;
    var _o5 = _l3.mask;

    for (var _e5 = 0; _e5 < f; _e5++) {
      for (var _i5 = 0; _i5 < u[_t6]; _i5++) {
        h[_e5 * a + _i5 + _n7] = null == _o5 ? 255 : _o5[_e5 * _l3.width + _i5];
      }
    }
  }

  for (var _t7 = 0; _t7 < p; _t7++) {
    var _n8 = new x(a * f);

    for (var _l4 = 0, _o6 = 0; _l4 < e.length; _o6 += u[_l4], _l4++) {
      var _r2 = e[_l4];
      if (!i(_r2)) continue;
      var _s2 = _r2.pixels[_t7];
      if (null != _s2) for (var _t8 = 0; _t8 < f; _t8++) {
        for (var _e6 = 0; _e6 < u[_l4]; _e6++) {
          _n8[_t8 * a + _e6 + _o6] = _s2[_t8 * _r2.width + _e6];
        }
      }
    }

    c.push(_n8);
  }

  var m = new n({
    width: a,
    height: f,
    mask: h,
    pixels: c,
    pixelType: r.pixelType
  });
  return m.updateStatistics(), m;
}

function M(t, e, n) {
  if (!i(t)) return null;
  var l = t.width,
      o = t.height,
      r = e.x,
      s = e.y,
      a = n.width + r,
      f = n.height + s;
  if (r < 0 || s < 0 || a > l || f > o) return t;
  if (0 === r && 0 === s && a === l && f === o) return t;
  t.mask || (t.mask = new Uint8Array(l * o));
  var h = t.mask;

  for (var _i6 = 0; _i6 < o; _i6++) {
    var _t9 = _i6 * l;

    for (var _e7 = 0; _e7 < l; _e7++) {
      h[_t9 + _e7] = _i6 < s || _i6 >= f || _e7 < r || _e7 >= a ? 0 : 1;
    }
  }

  return t.updateStatistics(), t;
}

function k(t) {
  if (!i(t)) return null;
  var e = t.clone(),
      n = t.width,
      l = t.height,
      o = t.pixels,
      r = t.mask,
      s = o[0],
      a = e.pixels[0];

  for (var _i7 = 2; _i7 < l - 1; _i7++) {
    var _t10 = new Map();

    for (var _l5 = _i7 - 2; _l5 < _i7 + 2; _l5++) {
      for (var _e9 = 0; _e9 < 4; _e9++) {
        var _i8 = _l5 * n + _e9;

        C(_t10, s[_i8], r ? r[_i8] : 1);
      }
    }

    a[_i7 * n] = A(_t10), a[_i7 * n + 1] = a[_i7 * n + 2] = a[_i7 * n];
    var _e8 = 3;

    for (; _e8 < n - 1; _e8++) {
      var _l6 = (_i7 - 2) * n + _e8 + 1;

      C(_t10, s[_l6], r ? r[_l6] : 1), _l6 = (_i7 - 1) * n + _e8 + 1, C(_t10, s[_l6], r ? r[_l6] : 1), _l6 = _i7 * n + _e8 + 1, C(_t10, s[_l6], r ? r[_l6] : 1), _l6 = (_i7 + 1) * n + _e8 + 1, C(_t10, s[_l6], r ? r[_l6] : 1), _l6 = (_i7 - 2) * n + _e8 - 3, U(_t10, s[_l6], r ? r[_l6] : 1), _l6 = (_i7 - 1) * n + _e8 - 3, U(_t10, s[_l6], r ? r[_l6] : 1), _l6 = _i7 * n + _e8 - 3, U(_t10, s[_l6], r ? r[_l6] : 1), _l6 = (_i7 + 1) * n + _e8 - 3, U(_t10, s[_l6], r ? r[_l6] : 1), a[_i7 * n + _e8] = A(_t10);
    }

    a[_i7 * n + _e8 + 1] = a[_i7 * n + _e8];
  }

  for (var _i9 = 0; _i9 < n; _i9++) {
    a[_i9] = a[n + _i9] = a[2 * n + _i9], a[(l - 1) * n + _i9] = a[(l - 2) * n + _i9];
  }

  return e.updateStatistics(), e;
}

function A(t) {
  if (0 === t.size) return 0;
  var e = 0,
      n = -1,
      i = 0;
  var l = t.keys();
  var o = l.next();

  for (; !o.done;) {
    i = t.get(o.value), i > e && (n = o.value, e = i), o = l.next();
  }

  return n;
}

function U(t, e, n) {
  if (0 === n) return;
  var i = t.get(e);
  1 === i ? t.delete(e) : t.set(e, i - 1);
}

function C(t, e, n) {
  0 !== n && t.set(e, t.has(e) ? t.get(e) + 1 : 1);
}

function T(t, e, l) {
  var o = e.x,
      r = e.y;
  var s = l.width,
      a = l.height;
  if (0 === o && 0 === r && a === t.height && s === t.width) return t;
  var f = t.width,
      h = t.height,
      u = Math.max(0, r),
      c = Math.max(0, o),
      p = Math.min(o + s, f),
      x = Math.min(r + a, h);
  if (p < 0 || x < 0 || !i(t)) return null;
  o = Math.max(0, -o), r = Math.max(0, -r);
  var m = t.pixels,
      d = t.mask,
      g = s * a,
      y = m.length,
      w = [];

  for (var _i10 = 0; _i10 < y; _i10++) {
    var _e10 = m[_i10],
        _l7 = n.createEmptyBand(t.pixelType, g);

    for (var _t11 = u; _t11 < x; _t11++) {
      var _n9 = _t11 * f;

      var _i11 = (_t11 + r - u) * s + o;

      for (var _t12 = c; _t12 < p; _t12++) {
        _l7[_i11++] = _e10[_n9 + _t12];
      }
    }

    w.push(_l7);
  }

  var M = new Uint8Array(g);

  for (var _n10 = u; _n10 < x; _n10++) {
    var _t13 = _n10 * f;

    var _e11 = (_n10 + r - u) * s + o;

    for (var _n11 = c; _n11 < p; _n11++) {
      M[_e11++] = d ? d[_t13 + _n11] : 1;
    }
  }

  var k = new n({
    width: l.width,
    height: l.height,
    pixelType: t.pixelType,
    pixels: w,
    mask: M
  });
  return k.updateStatistics(), k;
}

function S(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  if (!i(t)) return null;
  var l = t.pixels,
      o = t.width,
      r = t.height,
      s = t.mask,
      a = t.pixelType,
      f = [],
      h = Math.round(o / 2),
      u = Math.round(r / 2),
      c = r - 1,
      p = o - 1;

  for (var _i12 = 0; _i12 < l.length; _i12++) {
    var _t14 = l[_i12],
        _s3 = n.createEmptyBand(a, h * u);

    var _x = 0;

    for (var _n12 = 0; _n12 < r; _n12 += 2) {
      for (var _i13 = 0; _i13 < o; _i13 += 2) {
        var _l8 = _t14[_n12 * o + _i13];

        if (e) {
          var _e12 = _i13 === p ? _l8 : _t14[_n12 * o + _i13 + 1],
              _r3 = _n12 === c ? _l8 : _t14[_n12 * o + _i13 + o],
              _a2 = _i13 === p ? _r3 : _n12 === c ? _e12 : _t14[_n12 * o + _i13 + o + 1];

          _s3[_x++] = (_l8 + _e12 + _r3 + _a2) / 4;
        } else _s3[_x++] = _l8;
      }
    }

    f.push(_s3);
  }

  var x = null;

  if (s) {
    x = new Uint8Array(h * u);
    var _t15 = 0;

    for (var _n13 = 0; _n13 < r; _n13 += 2) {
      for (var _i14 = 0; _i14 < o; _i14 += 2) {
        var _l9 = s[_n13 * o + _i14];

        if (e) {
          var _e13 = _i14 === p ? _l9 : s[_n13 * o + _i14 + 1],
              _r4 = _n13 === c ? _l9 : s[_n13 * o + _i14 + o],
              _a3 = _i14 === p ? _r4 : _n13 === c ? _e13 : s[_n13 * o + _i14 + o + 1];

          x[_t15++] = _l9 * _e13 * _r4 * _a3 ? 1 : 0;
        } else x[_t15++] = _l9;
      }
    }
  }

  return new n({
    width: h,
    height: u,
    pixelType: a,
    pixels: f,
    mask: x
  });
}

function v(t, e, n) {
  if (!i(t)) return null;
  var l = e.width,
      o = e.height;
  var r = t.width,
      s = t.height;
  var a = new Map(),
      f = {
    x: 0,
    y: 0
  },
      h = null == n ? 1 : 1 + n;
  var u = t;

  for (var _i15 = 0; _i15 < h; _i15++) {
    var _t16 = Math.ceil(r / l),
        _n14 = Math.ceil(s / o);

    for (var _r5 = 0; _r5 < _n14; _r5++) {
      f.y = _r5 * o;

      for (var _n15 = 0; _n15 < _t16; _n15++) {
        f.x = _n15 * l;

        var _t17 = T(u, f, e);

        a.set("".concat(_i15, "/").concat(_r5, "/").concat(_n15), _t17);
      }
    }

    _i15 < h - 1 && (u = S(u)), r = Math.round(r / 2), s = Math.round(s / 2);
  }

  return a;
}

function B(t, e, l, o) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "nearest";
  if (!i(t)) return null;
  "majority" === r && (t = k(t));
  var _t18 = t,
      s = _t18.pixels,
      a = _t18.mask,
      f = _t18.pixelType,
      h = t.width,
      u = t.height,
      c = n.getPixelArrayConstructor(f),
      p = s.length,
      x = e.width,
      m = e.height,
      d = o.cols,
      g = o.rows,
      y = Math.ceil(x / d - .1 / d),
      w = Math.ceil(m / g - .1 / g);
  var M,
      A,
      U,
      C,
      T,
      S,
      v,
      B = !1;

  for (var _n16 = 0; _n16 < l.length; _n16 += 3) {
    -1 === l[_n16] && -1 === l[_n16 + 1] && -1 === l[_n16 + 2] && (B = !0);
  }

  var b = y * d,
      O = b * w * g,
      P = new Float32Array(O),
      z = new Float32Array(O);
  var I,
      W,
      j = 0;
  var D = "majority" === r ? 0 : .5;

  for (var _n17 = 0; _n17 < w; _n17++) {
    for (var _t19 = 0; _t19 < y; _t19++) {
      M = 12 * (_n17 * y + _t19), A = l[M], U = l[M + 1], C = l[M + 2], T = l[M + 3], S = l[M + 4], v = l[M + 5];

      for (var _e14 = 0; _e14 < g; _e14++) {
        j = (_n17 * g + _e14) * b + _t19 * d, W = (_e14 + .5) / g;

        for (var _t20 = 0; _t20 < _e14; _t20++) {
          I = (_t20 + .5) / d, P[j + _t20] = Math.round((A * I + U * W + C) * h - D), z[j + _t20] = Math.round((T * I + S * W + v) * u - D);
        }
      }

      M += 6, A = l[M], U = l[M + 1], C = l[M + 2], T = l[M + 3], S = l[M + 4], v = l[M + 5];

      for (var _e15 = 0; _e15 < g; _e15++) {
        j = (_n17 * g + _e15) * b + _t19 * d, W = (_e15 + .5) / g;

        for (var _t21 = _e15; _t21 < d; _t21++) {
          I = (_t21 + .5) / d, P[j + _t21] = Math.round((A * I + U * W + C) * h - D), z[j + _t21] = Math.round((T * I + S * W + v) * u - D);
        }
      }
    }
  }

  var E = function E(t, e) {
    for (var _n18 = 0; _n18 < m; _n18++) {
      M = _n18 * b;

      for (var _i16 = 0; _i16 < x; _i16++) {
        P[M] < 0 || z[M] < 0 ? t[_n18 * x + _i16] = 0 : t[_n18 * x + _i16] = e[P[M] + z[M] * h], M++;
      }
    }
  },
      $ = [];

  var q;

  for (var _n19 = 0; _n19 < p; _n19++) {
    q = new c(x * m), E(q, s[_n19]), $.push(q);
  }

  var F = new n({
    width: x,
    height: m,
    pixelType: f,
    pixels: $
  });
  if (a) F.mask = new Uint8Array(x * m), E(F.mask, a);else if (B) {
    F.mask = new Uint8Array(x * m);

    for (var _t22 = 0; _t22 < x * m; _t22++) {
      F.mask[_t22] = P[_t22] < 0 || z[_t22] < 0 ? 0 : 1;
    }
  }
  return F.updateStatistics(), F;
}

export { B as approximateTransform, T as clip, r as colorize, o as createColormapLUT, h as createContrastBrightnessLUT, u as createHistogramEqualizationLUT, f as createStretchLUT, a as estimateStatisticsFromHistograms, s as estimateStatisticsHistograms, l as extractBands, m as getClipBounds, i as isValidPixelBlock, p as lookupPixels, y as mosaic, d as mosaicPixelData, x as remapColor, k as resampleByMajority, M as setValidBoundary, v as split, c as stretch };